module.exports = __webpack_public_path__ + "img/slidesmall.ed72c9a6.gif";